/* カスタマイズ用JS */

document.addEventListener(
  "DOMContentLoaded",
  function () {

    const openCustomContactFormModal = () => {

      const open_btn = document.getElementById("custom-contact__modal-open-button");
      const modal = document.getElementById("custom-contact__modal");

      if (open_btn.length === 0 || modal.length === 0) return;

      open_btn.addEventListener("click", function () {
        modal.style.display = "block";
      });

      document.getElementById("custom-contact__modal-close").onclick = (e) => {
        modal.style.display = "none";
      };

      modal.addEventListener("click", (e) => {
        if (!e.target.closest(".custom-contact__modal-body")) {
          modal.style.display = "none";
        }
      });
    };

    openCustomContactFormModal();
  },
  false
);
